export default __webpack_public_path__ + "static/mv-d2caec742c088911513d391135985214.svg";